import { useState, useContext } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import BugReportIcon from "@mui/icons-material/BugReport";
import toast from "react-hot-toast";

import { AuthContext } from "../../context/auth-context";
import { ClinicaContext } from "../../context/clinica-context";
import { useHttpClient } from "../../hooks/http-hook";
import { useLoading } from "../../context/LoadingContext";

import "./ReportProblema.scss";

function ReportProblema() {
  const auth = useContext(AuthContext);
  const clinicaCtx = useContext(ClinicaContext);
  const { sendRequest } = useHttpClient();
  const { startLoading, stopLoading } = useLoading();

  const [open, setOpen] = useState(false);
  const [problema, setProblema] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = () => {
    if (isSubmitting) return;
    setOpen(false);
  };

  const handleSubmit = async () => {
    if (!problema.trim()) {
      toast.error("Descreve o problema antes de enviar.");
      return;
    }

    setIsSubmitting(true);
    startLoading();
    try {
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/email/reportar-problema`,
        "POST",
        JSON.stringify({
          userId: auth.userId,
          nome: auth.nome,
          clinica: clinicaCtx?.clinica?.nome || "",
          problema: problema.trim(),
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
      );

      toast.success("Report enviado. Obrigado pela ajuda! 🍫");
      setProblema("");
      setOpen(false);
    } catch (err) {
      toast.error(err.message || "Não foi possível enviar o report.");
    } finally {
      setIsSubmitting(false);
      stopLoading();
    }
  };

  if (!auth || !auth.token) return null;

  return (
    <>
      {/* Botão flutuante */}
      <button
        type="button"
        className="report-problema__fab"
        onClick={() => setOpen(true)}
        title="Reportar um problema"
      >
        <BugReportIcon className="report-problema__fab-icon" />
        <span className="report-problema__fab-label">Reportar problema</span>
      </button>

      <Modal open={open} onClose={handleClose}>
        <Box className="report-problema__modal">
          <h2 className="report-problema__titulo">Reportar um problema</h2>

          <Alert severity="info" className="report-problema__info">
            Encontrou alguma dificuldade ou comportamento estranho no sistema?
            Descreva o que aconteceu com o máximo de detalhe possível para que
            possamos analisar e corrigir.
          </Alert>

          <TextField
            multiline
            minRows={5}
            fullWidth
            label="Descrição do problema"
            placeholder="Ex.: Ao criar um orçamento direto, ao remover o desconto ficam duas parcelas..."
            value={problema}
            onChange={(e) => setProblema(e.target.value)}
            disabled={isSubmitting}
            sx={{ mt: 1 }}
          />

          <div className="report-problema__acoes">
            <Button
              variant="outlined"
              onClick={handleClose}
              disabled={isSubmitting}
              sx={{ textTransform: "none" }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={isSubmitting}
              sx={{ textTransform: "none" }}
            >
              {isSubmitting ? "A enviar..." : "Adicionar"}
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default ReportProblema;
